import { useMutation } from '@tanstack/react-query';
import axios from 'axios';

import { withZBSignature } from '../../services/security/zbSignature';

export const useEmailValidation = () =>
  useMutation(async (payload) => {
    const signedPayload = await withZBSignature(payload);
    const { data } = await axios.post('/api/auth/member/validate-email', signedPayload);
    return data;
  });
